import React from 'react'
import Schedule from '../../../assets/images/scheduleSmall.svg'
import { Flex, ResponsiveSVG } from 'ui/acro'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'

const Container = styled(Flex)({
  display: 'flex',
  height: '35px',
  padding: '0 16px',
  gap: '10px',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid #A3A3A3',
  borderRadius: '360px',
  marginTop: '4px',
  marginBottom: '8px',
  cursor: 'pointer'
})
const CTAText = styled(Text)({
  fontSize: ['14px'],
  fontFamily: 'Proxima-nova',
  fontWeight: 500,
  lineHeight: '18px',
  letterSpacing: '0.7px',
  color: '#000',
  textTransform: 'uppercase',
  '@media (min-width: 768px) and (max-width: 1199px)': {
    fontSize: '12px'
  }
})

const AddToCalendar = (props) => {
  const {
    id,
    title,
    description,
    coverUrl,
    startAt,
    endAt,
    timezone,
    locationType,
    city,
    region,
    venue,
    country,
    fullAddress,
    meetingUrl,
    hosts,
    lumaUrl
  } = props

  const eventCalendarData = {
    id,
    title,
    description,
    coverUrl,
    startAt,
    endAt,
    timezone,
    locationType,
    city,
    region,
    venue,
    country,
    fullAddress,
    meetingUrl,
    hosts,
    lumaUrl
  }

  const handleClick = (event) => {
    event?.preventDefault()
    event.stopPropagation()
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('source') === 'iosApp') {
      // iOS should have a listener for this
      window.webkit?.messageHandlers?.tokenHandler?.postMessage(
        eventCalendarData
      )
    } else {
      props?.handleEventAddToCalendarClick(eventCalendarData)
    }
  }

  return (
    <>
      <Container onClick={handleClick}>
        <CTAText>Add To Calendar</CTAText>
        <ResponsiveSVG
          SVG={Schedule}
          style={{
            cursor: 'pointer'
          }}
          width='16px'
          height='16px'
        />
      </Container>
    </>
  )
}
export default AddToCalendar
